import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import styles from '../EmployerCreation.module.scss';

const EmployerTitleSection = () => {
  const { formatMessage } = useIntl();
  const location = useLocation();

  const step = useMemo(() => (location.state?.from === 'pressedEmployerCreation' ? 2 : 1), [location.state]);
  const hideSteps = !location.pathname?.includes('congratulations');

  return (
    <>
      <h2 className={styles.EmployerTitle}>
        {formatMessage({ id: 'employer.creation.title' })}
      </h2>
      <p>{formatMessage({ id: 'employer.creation.subTitle' })}</p>
      <div className={styles.EmployerSubtitlesWrapper}>
        <ul className={styles.EmployerSubtitle}>
          <li>{formatMessage({ id: 'employer.creation.sublist.one' })}</li>
          <li>{formatMessage({ id: 'employer.creation.sublist.two' })}</li>
          <li>{formatMessage({ id: 'employer.creation.sublist.three' })}</li>
          <li>{formatMessage({ id: 'employer.creation.sublist.four' })}</li>
        </ul>
        {hideSteps && (
          <div className={styles.EmployerStep}>
            {formatMessage({ id: 'employer.creation.step' }, { step, of: 2 })}
          </div>
        )}
      </div>
    </>
  );
};

export default EmployerTitleSection;
